import { md5 } from '@pg/md5';

/**
 * 前后端和小程序通用签名库
 *
 * @packageDocumentation
 */
/**
 * object 转 query string
 * @param obj - 对象
 * @returns query string
 * @public
 */
function signObject(obj) {
    var rs = '';
    var arr = [];
    var keys = Object.keys(obj).sort();
    keys.forEach(function (key) {
        var val = obj[key];
        if (typeof val === 'object') {
            if (Array.isArray(val)) {
                arr.push("".concat(key, "=[").concat(signArray(val), "]"));
            }
            else {
                if (val !== null) {
                    arr.push("".concat(key, "={").concat(signObject(val), "}"));
                }
            }
        }
        else {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            arr.push("".concat(key, "=").concat(val));
        }
    });
    rs = arr.join('&');
    return rs;
}
/**
 * array 转 query string
 * @param array - 数组
 * @returns query string
 * @public
 */
function signArray(array) {
    var rs = '';
    var arr = [];
    array.forEach(function (val) {
        switch (val.constructor) {
            case Object:
                arr.push("{".concat(signObject(val), "}"));
                break;
            case Array:
                arr.push("[".concat(signArray(val), "]"));
                break;
            default:
                arr.push(val);
        }
    });
    rs = arr.join(',');
    return rs;
}
/**
 * 生成签名
 * @param apiKey - key
 * @param apiSecret - secret
 * @param params - 参数
 * @returns MD5
 * @public
 */
function enc(apiKey, apiSecret, params) {
    var rs = '';
    var parameters = params;
    if (apiKey) {
        parameters.apiKey = apiKey;
    }
    var origin = signObject(parameters) + apiSecret;
    rs = md5(origin);
    return rs;
}
/**
 * 仅校验签名算法，不做timestamp检查
 * @param apiKey - key
 * @param apiSecret - secret
 * @param params - 参数
 * @returns 校验结果
 * @public
 */
function loose(apiKey, apiSecret, params) {
    var rs = false;
    var parameters = JSON.parse(JSON.stringify(params));
    if (parameters.sig) {
        parameters.apiKey = apiKey;
        var sig = params.sig;
        delete parameters.sig;
        var mySig = md5(signObject(parameters) + apiSecret);
        if (mySig === sig) {
            rs = true;
        }
    }
    return rs;
}
/**
 * 签名强校验，检查 timestamp 有效性（60s 以内）
 * @param apiKey - key
 * @param apiSecret - secret
 * @param params - 参数
 * @returns 校验结果
 * @public
 */
function verify(apiKey, apiSecret, params) {
    var rs = false;
    var parameters = JSON.parse(JSON.stringify(params));
    if (parameters.sig && parameters.timestamp) {
        var now = Math.floor(Date.now() / 1000);
        var timestamp = parseInt(parameters.timestamp);
        if (now - timestamp < 60) {
            parameters.apiKey = apiKey;
            var sig = params.sig;
            delete parameters.sig;
            var mySig = md5(signObject(parameters) + apiSecret);
            if (mySig === sig) {
                rs = true;
            }
        }
    }
    return rs;
}

export { enc, loose, signArray, signObject, verify };
